import { useTranslation } from "react-i18next";
const capitalizeFirstLetter = (string: string) => {
  if (string === string.toUpperCase()) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }
  return string
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

const useSelectOptions = (useCapitalize: boolean, options: string[]) => {
  const { t } = useTranslation();

  return options.map((option) => {
    const transformedOption = capitalizeFirstLetter(option);
    return {
      label: useCapitalize ? t(transformedOption) : t(option),
      value: option,
    };
  });
};

export const useInterestsTags = () =>
  useSelectOptions(false, [
    "Gym",
    "StrengthTraining",
    "Bodybuilding",
    "HomeWorkout",
    "Yoga",
    "Pilates",
    "Running",
    "HIIT",
    "Functional",
    "Mobility",
    "Stretching",
    "Pregnancy",
    "Postnatal",
    "Meditation",
    "Mindfulness",
    "Aerobics",
    "NoTools",
    "Hybrid",
  ]);

export const useFilterTags = () =>
  useSelectOptions(false, [
    "StrengthTraining",
    "Yoga",
    "Pilates",
    "Aerobics",
    "HIIT",
    "Running",
    "BodyWeight",
    "Mobility",
    "Stretching",
    "Gym",
    "Bodybuilding",
    "HomeWorkout",
    "NoTools",
    "WeightsOnly",
    "Pregnancy",
    "Postnatal",
    "Meditation",
    "Mindfulness",
    "Warmup",
    "UpperBody",
    "LowerBody",
    "Chest",
    "Shoulders",
    "Back",
    "Biceps",
    "Triceps",
    "Buttock",
    "Legs",
    "Stomach",
    "FullBody",
    "Pull",
    "Push",
    "KneeFriendly",
    "WomenFriendly",
    "UpTo15Min",
    "UpTo30Min",
    "UpTo60Min",
    "Functional",
    "Hybrid",
  ]);

export const useDifficultyOptions = () =>
  useSelectOptions(false, [
    "BEGINNER",
    "INTERMEDIATE",
    "ADVANCED",
    "PROFESSIONAL",
    "BEGINNER_FEMALE",
    "CONTINUING_FEMALE",
    "ADVANCED_FEMALE",
    "PROFESSIONAL_FEMALE",
    "EXTREME",
    "TRIMESTER_1",
    "TRIMESTER_2",
    "TRIMESTER_3",
    "STAGE_1",
    "STAGE_2",
    "STAGE_3",
    "STAGE_4",
    "STAGE_5",
  ]);

export const useMusclesOptions = () => {
  return useSelectOptions(true, ["chest", "shoulders", "biceps", "triceps", "back", "quadriceps", "hamstrings", "glutes", "calves", "abs", "trapezius", "innerThigh"]);
};

export const useEquipmentTypeOptions = () => {
  return useSelectOptions(true, ["none", "minimal", "minimalGym", "commercialGym"]);
};

export const usePartTypes = () =>
  useSelectOptions(false, [
    "EMOM",
    "AMRAP",
    "superSet",
    "warmUp",
    "stretches",
    "dynamicWarmup",
    "dropSet",
    "core",
    "rounds",
    "mobility",
    "training",
    "activation",
    "tripleSet",
    "metcon",
    "finisher",
    "TABATA",
    "running",
    "sprint",
    "intervals",
    "powerBlock",
    "stations",
  ]);

export const useRecipeTagsOptions = () =>
  useSelectOptions(false, [
    "Breakfast",
    "Snack",
    "Lunch",
    "Dinner",
    "MainCourse",
    "SideDish",
    "Meat",
    "Dairy",
    "GlutenFree",
    "Vegan",
    "Vegetarian",
    "KosherForPassover",
    "Dessert",
    "MealPrep",
    "Holidays",
    "Pasta",
    "Salad",
    "Smoothies",
    "Fish",
    "Brunch",
    "Under20Minutes",
    "Under10Minutes",
    "PreWorkout",
    "LowCarb",
    "Keto",
    "Under200Calories",
    "Under300Calories",
    "Under400Calories",
    "Under500Calories",
    "Over500Calories",
  ]);
